// extracted by mini-css-extract-plugin
module.exports = {"background_div":"Dashbord_background_div__1WoKL","tab_bg":"Dashbord_tab_bg__1qeKP","tabpane_div":"Dashbord_tabpane_div__1KQsz","graph_div1":"Dashbord_graph_div1__2BADN"};